export default {
      id: "sports_baseball-usage",
      viewBox: "0 0 24 24",
      url: __webpack_public_path__ + "img/icons.845ff42f.svg#sports_baseball",
      toString: function () {
        return this.url;
      }
    }